import restApi from "@plannel/services/utils/rest-api";

const get = pageCd => {
  return restApi.get(`/api/p13n/${pageCd}`);
}

const getWithDisplayName = pageCd => {
  return restApi.get(`/api/p13n/displayName/${pageCd}`);
}

const getMerged = pageCd => {
  return restApi.get(`/api/p13n/merged/${pageCd}`);
}

const getLayout = pageCd => {
  return restApi.get(`/api/p13n/layout/${pageCd}`);
}

const getDefaultLayout = pageCd => {
  return restApi.get(`/api/p13n/layout/default/${pageCd}`);
}

const upsertLayout = params => {
  return restApi.post("/api/p13n/layout", params);
}

const upsert = params => {
  return restApi.post("/api/p13n", params);
}

const deleteP13n = ids => {
  return restApi.delete(`/api/p13n/${ids}`);
}

const upsertMeasure = params => {
  return restApi.post("/api/p13n/measure", params);
}

const p13nService = {
  get,
  getWithDisplayName,
  getMerged,
  getLayout,
  getDefaultLayout,
  upsert,
  upsertMeasure,
  upsertLayout,
  deleteP13n
};

export default p13nService;